export const AI_RECEPTIONIST_FIELD_MASK_PATH_PREFIX_BASE = 'aiReceptionistLocationUserSettings.';
